import { Icon } from '@components';
import amb1 from '@pngs/AboutUsPage/ambassador1.png';
import amb2 from '@pngs/AboutUsPage/ambassador2.png';
import amb3 from '@pngs/AboutUsPage/ambassador3.png';
import amb4 from '@pngs/AboutUsPage/ambassador4.png';
import b1 from '@pngs/AboutUsPage/banner2_1.png';
import b2 from '@pngs/AboutUsPage/banner2_2.png';
import b3 from '@pngs/AboutUsPage/banner2_3.png';
import b4 from '@pngs/AboutUsPage/banner2_4.png';
import b5 from '@pngs/AboutUsPage/banner2_5.png';
import Noise from '@pngs/Noise5.png';
import { Flex, Image, Typography } from '@styles';
import { ReactComponent as DecorationSVG } from '@svgs/decoration.svg';
import { media } from '@utils';
import React from 'react';
import styled, { css } from 'styled-components';

const { laptop, mobile, tabletLG } = media;
export const StyledTypography = styled(Typography)`
  ${({ founders, isTitle }) => css`
    ${!founders &&
    !isTitle &&
    `
    @media (max-width: 1150px) {
      font-size: 18px;
    }
    `}
    ${tabletLG} {
      ${!isTitle && 'font-size: 16px;'}
    }
  `}
`;

export const StyledImage = styled(Image)`
  ${({ founders }) => css`
    ${founders
      ? `
      height: 880px;
      width: auto;
      @media (max-width: 1300px) {
        height: 800px;
        right: -5%;
      }
      @media (max-width: 1150px) {
        height: 800px;
        right: -10%;
      }
      ${tabletLG} {
        height: 450px;
        left: 50%;
        transform: translate(-50%, 0%);
      }
      ${mobile} {
        width: 100%;
        height: auto;
      }
      `
      : `
    width: 840px;
    height: auto;
    z-index: 1;
    @media (max-width: 1300px) {
      width: 60%;
    }
    ${tabletLG} {
      width: 100%;
    }
  `}
  `}
`;

export const StyledTypographyBanner = styled(Typography)`
  ${({ theme: { colors }, withoutMB }) => css`
    font-size: 16px;
    color: ${colors.white[100]};
    opacity: 0.6;
    ${!withoutMB && 'margin-bottom: 50px;'}
    width: 370px;
    ${tabletLG} {
      width: 100%;
      margin-bottom: 20px;
    }
  `}
`;

export const StyledFlex = styled(Flex)`
  ${() => css`
    height: 100%;
    width: 100%;
    background-image: url('${Noise}');
    background-size: cover;
    z-index: 13;
  `}
`;

export const StyledWrapper = styled(Flex)`
  ${({ general }) => css`
    margin-top: ${general ? 0 : 40}px;
    gap: 16px;
    flex-direction: column;
    ${tabletLG} {
      margin-top: 20px;
    }
  `}
`;

export const Decoration = (props) => (
  <Icon position="absolute" SVG={DecorationSVG} {...(props && { ...props })} />
);

export const StyledDecoration = styled(Icon)`
  ${() => css`
    right: 0;
    bottom: 25%;
    z-index: 3;
    transform: translate(30%, 0);
    ${laptop} {
      display: none;
    }
  `}
`;

export const ambassadors = [
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
    id: 3,
    image: amb1,
    title: 'Name courses on two lines',
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
    id: 4,
    image: amb2,
    title: 'Name courses on two lines',
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
    id: 5,
    image: amb3,
    title: 'Name courses on two lines',
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
    id: 6,
    image: amb4,
    title: 'Name courses on two lines',
  },
];

export const imgProps = [
  { src: b1, width: '257px' },
  { src: b2, width: '273px' },
  { src: b3, width: '461px' },
  { src: b4, width: '345px' },
  { src: b5, width: '171px' },
];

export const aboutUsLayoutByVariant = {
  desktop: {
    px: 156,
  },
  laptop: {
    px: 24,
  },
  mobile: {
    px: 16,
  },
  tablet: {
    px: 24,
  },
};
